import styled from 'styled-components';

export const ProfileEditingWrapper = styled.div``;
